<template>
  <v-row class="mb-8">

    <v-col cols="12" class="mt-4" v-if="!$vuetify.breakpoint.xs">
      <v-tabs
        fixed-tabs
        v-model="tabs"
        class="tab-gallery"
        :background-color="color_tab"
        slider-size="8"
        dark
        height="70px"
      >
        <v-tab @click="handleTabChange(0)">
          <v-icon class="mr-6">mdi-account-group-outline</v-icon>
          Emprendedores
        </v-tab>

        <v-tab @click="handleTabChange(1)">
          <v-icon class="mr-6">mdi-account-supervisor-outline</v-icon>
          Asistentes
        </v-tab>

      </v-tabs>
    </v-col>
    
    <v-col cols="12" v-if="$vuetify.breakpoint.xs">
      <v-tabs
        fixed-tabs
        v-model="tabs"
        class="tab-gallery"
        :background-color="color_tab"
        slider-size="8"
        dark
        height="70px"
      >
        <v-tab @click="handleTabChange(0)">
          <v-icon class="mr-6">mdi-account-group-outline</v-icon>
        </v-tab>
        <v-tab @click="handleTabChange(1)">
          <v-icon>mdi-account-supervisor-outline</v-icon>
        </v-tab>
      </v-tabs>

      <h4 v-if="tabs===0" class="pt-4" align="center">
        Emprendedores
      </h4>
      <h4 v-if="tabs===1" class="pt-4" align="center">
        Asistentes
      </h4>
    </v-col>

    <v-col cols="12" v-if="tabs===0">
      <v-row>
        <v-col cols="9" sm="9" xs="12">
          <v-text-field
            v-model="search_assistant"
            label="Buscar emprendedor"
            outlined
            clearable
            background-color="white"
            hide-details
            @keyup.enter="clickFind"
            @click:clear="onClear"
          />
        </v-col>

        <v-col cols="3" sm="3" xs="12" class="d-flex align-center">
          <!-- Botón con texto (solo md y superiores) -->
          <v-btn
            class="d-none d-sm-flex"
            block
            height="54px"
            :color="color_tab"
            dark
            @click="clickFind"
          >
            <v-icon start>mdi-magnify</v-icon>
            Buscar
          </v-btn>

          <!-- Botón solo con icono (xs) -->
          <v-btn
            class="d-flex d-sm-none mx-auto"
            height="54px"
            :color="color_tab"
            dark
            @click="clickFind"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" v-if="tabs===1">
      <v-row>
        <v-col cols="9">
          <v-text-field
            v-model="search_assistant"
            label="Buscar asistente"
            outlined
            clearable
            background-color="white"
            hide-details
            @keyup.enter="clickFind"
            @click:clear="onClear"
          ></v-text-field>
        </v-col>

        <v-col cols="3" sm="3" xs="12" class="d-flex align-center">
          <!-- Botón con texto (solo md y superiores) -->
          <v-btn
            class="d-none d-sm-flex"
            block
            height="54px"
            :color="color_tab"
            dark
            @click="clickFind"
          >
            <v-icon start>mdi-magnify</v-icon>
            Buscar
          </v-btn>

          <!-- Botón solo con icono (xs) -->
          <v-btn
            class="d-flex d-sm-none mx-auto"
            height="54px"
            :color="color_tab"
            dark
            @click="clickFind"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>

    <v-col 
      cols="12" 
      xl="3" 
      md="3"
      sm="6" 
      xs="12" 
      align="center"
      v-for="(participant) in participants" 
      :key="participant.id">
      <cardParticipant 
        v-if="tabs===0 && !loading" 
        :data="participant" 
        :backgroundCardParticipant="entrepreur_background_card" />

      <cardAssistant 
        v-if="tabs===1 && !loading" 
        :data="participant" 
        :backgroundCardAssistant="assistant_background_card"/>
    </v-col>

    <v-col cols="12" class="text-center" v-if="tabs==0 && !loading">
      <v-row>
        <v-col cols="12">
          <v-pagination
            v-model="current_page"
            @input="getEntrepreneursEdition"
            :length="totalPages"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" class="text-center" v-if="tabs==1 && !loading">
      <v-row>
        <v-col cols="12">
          <v-pagination
            v-if="!paginate_search"
            v-model="current_page"
            @input="getAssistantsEdition"
            :length="totalPages"
          ></v-pagination>

          <v-pagination
            v-if="paginate_search"
            v-model="current_page"
            @input="findAssistant"
            :length="totalPages"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL
  import { mapGetters } from 'vuex'
  import cardParticipant from '@/components/card/cardParticipant'
  import cardAssistant from '@/components/card/cardAssistant'

  export default {
    name: 'participantsEdition',
    components:{cardParticipant, cardAssistant},
    data: () => ({
      loading:true,
      current_page: 1,
      totalPages:0,
      pages: 0,
      tabs: 0,
      data: null,
      participants: [],
      edition_id: null,
      
      entrepreur_background_card: null,
      assistant_background_card: null,

      find:null,
      search_assistant: null
    }),
    computed: {
      ...mapGetters([
        'edition'
      ]),

      color_tab () {
        switch (this.tabs) {
          case 0: return '#00A1B8'
          case 1: return '#23495C'
          default: return '#00A1B8'
        }
      }, 
    },
    watch: {
      // Watcher para type_assistants
      tabs(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loading=true
          if(this.tabs==0){
            this.current_page = 1
            this.getEntrepreneursEdition()
          }
          if(this.tabs==1){
            this.current_page = 1
            this.getAssistantsEdition()
          }
        }
      }
    },
    methods:{
      buscar(){
        alert('buscar')
      },

      setData(){
        this.entrepreur_background_card = APP_URL + this.edition.edition.edition_customization.entrepreur_background_card
        this.assistant_background_card = APP_URL + this.edition.edition.edition_customization.assistant_background_card
      },

      async getEntrepreneursEdition(){
        this.loading = true
        this.participants = []
        await axios.get('participant/participants/'+this.edition.edition.id+'/entrepreneurs?page='+this.current_page).then(response =>{
          this.data = response.data.data.participants
          this.participants = response.data.data.participants.data
          this.current_page = response.data.data.participants.current_page
          this.totalPages = response.data.data.participants.last_page;
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      async getAssistantsEdition(){
        this.loading = true
        this.participants = []
        await axios.get('participant/participants/'+this.edition.edition.id+'/assistants?page='+this.current_page).then(response =>{
          this.data = response.data.data.participants
          this.participants = response.data.data.participants.data
          this.current_page = response.data.data.participants.current_page
          this.totalPages = response.data.data.participants.last_page;
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      handleTabChange(tab){
        this.tabs = tab
      },

      clickFind() {
        this.current_page = 1
        if (this.tabs == 1) {
          this.findAssistant();
        } else {
          this.findEntrepreneurs();
        }
      },
      onClear() {
        this.current_page = 1
        this.search_assistant = null
        this.$nextTick(() => {
          if (this.tabs == 1) {
            this.findAssistant();
          } else {
            this.findEntrepreneurs();
          }
        })
      },
      async findEntrepreneurs() {
        if(this.search_assistant && this.search_assistant!=''){
          this.paginate_search = true
          this.loading = true
          this.participants = []
          axios.get(`/participant/participants/${this.edition.edition.id}/entrepreneurs/find`, {
            params: { page: this.current_page, search: this.search_assistant }
          }).then(response =>{
            this.data = response.data.data.participants
            this.participants = response.data.data.participants.data
            this.current_page = response.data.data.participants.current_page
            this.totalPages = response.data.data.participants.last_page;
            this.loading=false
          }).catch(error => {
            console.log(error);
          })
        }else{
          this.paginate_search = false
          this.getEntrepreneursEdition()
        }
      },
      async findAssistant() {
        if(this.search_assistant && this.search_assistant!=''){
          this.paginate_search = true
          this.loading = true
          this.participants = []
          axios.get(`/participant/participants/${this.edition.edition.id}/assistants/find`, {
            params: { page: this.current_page, search: this.search_assistant }
          }).then(response =>{
            this.data = response.data.data.participants
            this.participants = response.data.data.participants.data
            this.current_page = response.data.data.participants.current_page
            this.totalPages = response.data.data.participants.last_page;
            this.loading=false
          }).catch(error => {
            console.log(error);
          })
        }else{
          this.paginate_search = false
          this.getAssistantsEdition()
        }
      },

      handleEdition(){
        if(this.edition.edition.waiting_room){
          this.loading = false
          this.$router.push({ name: 'home' })
        }
      }
    },
    created(){
      Promise.all([
        this.handleEdition(),
        this.setData(),
        this.getEntrepreneursEdition()
      ]).then(() => {
        this.loading=false
      }).catch((error) => {
        console.log(error)
      });
    }
  }
</script>
<style scoped>
.tab-gallery {
  border-radius: 6px!important;
  background-color: linear-gradient(to right,#00a1b8 0%,#23495c 100%) !important;
}
</style>
